import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';
import RemakeTasksList from './RemakeTasksList';

export default ColumnsContent(RemakeTasksList);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/EarnMoney/RemakeTasksList/index.js